//Six

window.__MEAL_CARD_CACHE = window.__MEAL_CARD_CACHE || new Map();

const DISCOUNT_TIERS = [
  { min: 7, max: 10, percent: 5, label: '5% OFF Applied' },
  { min: 11, max: 15, percent: 10, label: '10% OFF Applied' },
  { min: 16, max: 20, percent: 12, label: '12% OFF Applied' },
  { min: 21, max: Infinity, percent: 15, label: '15% OFF Applied' }
];

function getCardDebugId(card) {
  const handle = card
    .querySelector('.sealsubs-target-element[data-handle]')
    ?.getAttribute('data-handle');
  if (handle) return handle;
  return `card-${Array.from(document.querySelectorAll('.product-item-v7')).indexOf(card)}`;
}

// ============================================
// DISCOUNT HELPERS
// ============================================
function getDiscountTier(mealCount) {
  return DISCOUNT_TIERS.find(tier => mealCount >= tier.min && mealCount <= tier.max) || null;
}

function showDiscountPopup(tier) {
  const popup = document.getElementById('discount-popup');
  if (!popup) return;

  popup.classList.remove('show', 'hide');

  const titleEl = popup.querySelector('.popup-title');
  const subtitleEl = popup.querySelector('.popup-subtitle');

  titleEl.textContent = `${tier.percent}% OFF unlocked!`;
  subtitleEl.textContent = `for ${tier.min}+ meals`;

  popup.offsetHeight;
  popup.classList.add('show');

  setTimeout(() => {
    popup.classList.remove('show');
    popup.classList.add('hide');
  }, 3000);
}

function updateDiscountDisplay(mealCount) {
  const discountTwoEl = document.querySelector('.discount-two');
  if (!discountTwoEl) return;

  const tier = getDiscountTier(mealCount);

  if (tier && mealCount >= tier.min) {
    discountTwoEl.textContent = tier.label;
    discountTwoEl.style.display = 'inline-block';

    const currentTier = window.lastDiscountTier;
    if (!currentTier || currentTier.percent !== tier.percent) {
      showDiscountPopup(tier);
      window.lastDiscountTier = tier;
    }
  } else {
    discountTwoEl.style.display = 'none';
    window.lastDiscountTier = null;
  }
}

// ============================================
// SEAL SUBS HELPERS
// ============================================
function getSealPurchaseType(card) {
  const container = card.querySelector('.sls-purchase-options-container');
  if (!container) return 'one_time';

  const activeRadio = container.querySelector('.sls-option-container.sls-active input[type="radio"]');
  const type = activeRadio?.getAttribute('data-type');

  return type === 'subscription' ? 'subscription' : 'one_time';
}

function getSelectedSellingPlanId(card) {
  const intervalSelect = card.querySelector('.sls-purchase-options-container select[name="subs_interval"]');
  if (intervalSelect?.value) return String(intervalSelect.value);

  const hiddenSellingPlan = card.querySelector('.sls-purchase-options-container input[name="selling_plan"]');
  if (hiddenSellingPlan?.value) return String(hiddenSellingPlan.value);

  return null;
}

function getProductJsonFromCard(card) {
  const sealEl = card.querySelector(
    '.sealsubs-target-element.sealsubs-full[data-product], .sealsubs-target-element[data-product]'
  );
  const raw = sealEl?.getAttribute('data-product');

  if (!raw) {
    console.warn('[MealPrice] data-product not found on Seal element for', getCardDebugId(card));
    return null;
  }

  try {
    return JSON.parse(raw);
  } catch (e) {
    console.warn('[MealPrice] Invalid Seal data-product JSON for', getCardDebugId(card), e);
    return null;
  }
}

// NEW: read global selector value (works even when 0 meals selected)
function getGlobalSubscriptionValue() {
  const el = document.getElementById('global-subscription-select');
  return el?.value || 'one_time';
}

function isGlobalOneTime() {
  return getGlobalSubscriptionValue() === 'one_time';
}

// ============================================
// VARIANT / CACHE
// ============================================
function getVariantIdFromCard(card) {
  const idField = card.querySelector('select[name="id"], input[name="id"]');
  return idField?.value ? String(idField.value) : null;
}

function buildCardCache(card) {
  if (window.__MEAL_CARD_CACHE.has(card)) return window.__MEAL_CARD_CACHE.get(card);

  let productData = getProductJsonFromCard(card);

  if (!productData) {
    const form = card.querySelector('form[action="/cart/add"]');
    const dataProduct = form?.getAttribute('data-product');
    if (dataProduct) {
      try {
        productData = JSON.parse(dataProduct);
      } catch (e) {
        console.warn('[MealPrice] Invalid form data-product JSON for', getCardDebugId(card), e);
      }
    }
  }

  const cache = {
    productData,
    variants: Array.isArray(productData?.variants) ? productData.variants : [],
    activeVariantId: getVariantIdFromCard(card),
    basePrice: null
  };

  cache.basePrice = getPriceFromCache(card, cache);
  window.__MEAL_CARD_CACHE.set(card, cache);

  console.log('[MealPrice] Cache built:', {
    card: getCardDebugId(card),
    hasProductData: !!cache.productData,
    variantsCount: cache.variants.length,
    activeVariantId: cache.activeVariantId,
    basePrice: cache.basePrice
  });

  return cache;
}

function getPriceFromCache(card, cache) {
  const cardId = getCardDebugId(card);
  const vId = cache.activeVariantId || getVariantIdFromCard(card);

  if (!cache.productData) {
    console.warn('[MealPrice] No productData; fallback 5.99 for', cardId);
    return 5.99;
  }

  if (vId && cache.variants?.length) {
    const v = cache.variants.find(x => String(x.id) === String(vId));
    if (!v) {
      console.warn('[MealPrice] Variant not found in JSON; fallback productData.price for', cardId, vId);
      if (typeof cache.productData.price !== 'undefined') return (Number(cache.productData.price) || 0) / 100;
      return 5.99;
    }

    const purchaseType = getSealPurchaseType(card);
    const sellingPlanId = getSelectedSellingPlanId(card);

    console.log('[MealPrice] Pricing context:', {
      card: cardId,
      variantId: vId,
      purchaseType,
      sellingPlanId
    });

    if (purchaseType === 'one_time') {
      const cents = Number(v.price) || 0;
      console.log('[MealPrice] One-time price used:', { card: cardId, cents, price: cents / 100 });
      return cents / 100;
    }

    const allocations = v.selling_plan_allocations || v.sellingplanallocations || [];

    if (purchaseType === 'subscription') {
      if (!sellingPlanId) {
        console.warn('[MealPrice] Subscription selected but no sellingPlanId; fallback to variant.price for', cardId);
        return (Number(v.price) || 0) / 100;
      }

      if (!allocations.length) {
        console.warn('[MealPrice] Subscription selected but no allocations on variant; fallback to variant.price for', cardId);
        return (Number(v.price) || 0) / 100;
      }

      const alloc = allocations.find(a =>
        String(a.selling_plan_id || a.sellingplanid) === String(sellingPlanId)
      );

      if (!alloc) {
        console.warn('[MealPrice] No matching allocation found; fallback to variant.price for', cardId, {
          sellingPlanId,
          allocationsFound: allocations.map(a => a.selling_plan_id || a.sellingplanid)
        });
        return (Number(v.price) || 0) / 100;
      }

      const cents =
        Number(alloc.per_delivery_price) ||
        Number(alloc.perdeliveryprice) ||
        Number(alloc.price) ||
        0;

      console.log('[MealPrice] Subscription price used:', {
        card: cardId,
        sellingPlanId,
        cents,
        price: cents ? (cents / 100) : null
      });

      if (cents) return cents / 100;

      console.warn('[MealPrice] Allocation had no usable cents; fallback to variant.price for', cardId);
      return (Number(v.price) || 0) / 100;
    }

    return (Number(v.price) || 0) / 100;
  }

  if (typeof cache.productData.price !== 'undefined') {
    return (Number(cache.productData.price) || 0) / 100;
  }

  return 5.99;
}

function syncCardCacheVariant(card) {
  const cache = buildCardCache(card);
  if (!cache) return null;

  cache.activeVariantId = getVariantIdFromCard(card);
  cache.basePrice = getPriceFromCache(card, cache);

  console.log('[MealPrice] Cache sync:', {
    card: getCardDebugId(card),
    activeVariantId: cache.activeVariantId,
    basePrice: cache.basePrice
  });

  return cache;
}

function getCachedCardPrice(card) {
  const cache = buildCardCache(card);
  if (!cache) return 5.99;
  syncCardCacheVariant(card);
  return cache.basePrice;
}

// ============================================
// NEW: ORIGINAL (NO DISCOUNT) PRICE HELPERS
// ============================================
// This returns the "regular" one-time variant price (ignores subscription allocation price).
function getOneTimePriceForCard(card) {
  const cache = buildCardCache(card);
  if (!cache) return 0;

  const vId = cache.activeVariantId || getVariantIdFromCard(card);
  if (vId && cache.variants?.length) {
    const v = cache.variants.find(x => String(x.id) === String(vId));
    if (v && typeof v.price !== 'undefined') return (Number(v.price) || 0) / 100;
  }

  if (typeof cache.productData?.price !== 'undefined') return (Number(cache.productData.price) || 0) / 100;
  return 0;
}

function calculateOriginalTotalPrice(selectedMeals) {
  if (!selectedMeals || selectedMeals.size === 0) return 0;

  let total = 0;
  selectedMeals.forEach(item => {
    const card = item.card;
    const originalPerItem = card ? getOneTimePriceForCard(card) : (item.price || 0);
    total += originalPerItem * item.quantity;
  });
  return total;
}

// ============================================
// CENTRALIZED SUBSCRIPTION SELECTOR
// ============================================
function initCentralizedSubscriptionSelector() {
  const selectorContainer = document.createElement('div');
  selectorContainer.className = 'centralized-subscription-selector';
  selectorContainer.innerHTML = `
    <div class="selector-wrapper">
      <label for="global-subscription-select">Frequency</label>
      <select id="global-subscription-select" class="global-subscription-select">
        <option value="one_time">One-time purchase</option>
        <option value="4_weeks">Subscription - 4 weeks</option>
        <option value="6_weeks">Subscription - 6 weeks</option>
      </select>
    </div>
  `;

  const targetElement = document.querySelector('#selectPlan');
  if (targetElement) {
    targetElement.appendChild(selectorContainer);
  } else {
    console.warn('Target element not found: #selectPlan');
  }

  const globalSelect = document.getElementById('global-subscription-select');
  if (globalSelect) {
    globalSelect.addEventListener('change', (e) => {
      const selectedValue = e.target.value;
      applySubscriptionToAllCards(selectedValue);
    });

    applySubscriptionToAllCards('4_weeks');
  }
}

function applySubscriptionToAllCards(selectedValue) {
  const purchaseContainers = document.querySelectorAll('.sls-purchase-options-container');

  purchaseContainers.forEach((container) => {
    if (selectedValue === 'one_time') {
      selectOneTimePurchase(container);
    } else if (selectedValue === '4_weeks') {
      selectSubscriptionByLabel(container, '4 weeks');
    } else if (selectedValue === '6_weeks') {
      selectSubscriptionByLabel(container, '6 weeks');
    }
  });

  // IMPORTANT: update sidebar discount + price-info even if mealCount is 0
  setTimeout(() => {
    updateSidebarDiscountFromCards();
    updateSelectedMealsPrices();
    updateMealsStatus(window.currentSelectedMeals || new Map());
  }, 300);

  // safety re-check (Seal sometimes updates badge slightly later)
  setTimeout(() => {
    updateSidebarDiscountFromCards();
    updateMealsStatus(window.currentSelectedMeals || new Map());
  }, 700);
}

function selectOneTimePurchase(container) {
  const oneTimeRadio =
    container.querySelector('input[data-type="one_time"]') ||
    container.querySelector('input[data-type="onetime"]');

  if (oneTimeRadio) {
    oneTimeRadio.checked = true;
    oneTimeRadio.dispatchEvent(new Event('change', { bubbles: true }));
    const radioParent = oneTimeRadio.closest('[role="radio"]');
    if (radioParent) radioParent.setAttribute('aria-checked', 'true');
  } else {
    console.warn('[MealPrice] One-time radio not found in container');
  }

  const subRadios = container.querySelectorAll('input[data-type="subscription"]');
  subRadios.forEach((radio) => {
    radio.checked = false;
    const parent = radio.closest('[role="radio"]');
    if (parent) parent.setAttribute('aria-checked', 'false');
  });

  updateContainerActiveState(container);

  // **FIX**: Clear selling_plan for one-time purchase
  const hiddenSellingPlan = container.querySelector('input[name="selling_plan"]');
  if (hiddenSellingPlan) hiddenSellingPlan.value = '';

  // Hide + clear discount immediately
  const sidebarDiscountEl = document.querySelector('.order-summary-box .discount');
  if (sidebarDiscountEl) {
    sidebarDiscountEl.textContent = '';
    sidebarDiscountEl.style.display = 'none';
  }
}

function selectSubscriptionByLabel(container, weekLabel) {
  const intervalSelect = container.querySelector('select[name="subs_interval"]');
  if (intervalSelect) {
    const targetOption = Array.from(intervalSelect.options).find(opt =>
      opt.textContent.trim().includes(weekLabel)
    );
    if (targetOption) {
      intervalSelect.value = targetOption.value;
      intervalSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  const subRadio = container.querySelector('input[data-type="subscription"]');
  if (subRadio) {
    subRadio.checked = true;
    subRadio.dispatchEvent(new Event('change', { bubbles: true }));
    const radioParent = subRadio.closest('[role="radio"]');
    if (radioParent) radioParent.setAttribute('aria-checked', 'true');
  }

  const oneTimeRadio =
    container.querySelector('input[data-type="one_time"]') ||
    container.querySelector('input[data-type="onetime"]');

  if (oneTimeRadio) {
    oneTimeRadio.checked = false;
    const parent = oneTimeRadio.closest('[role="radio"]');
    if (parent) parent.setAttribute('aria-checked', 'false');
  }

  updateContainerActiveState(container);

  // **FIX**: Force update hidden selling_plan input
  setTimeout(() => {
    const hiddenSellingPlan = container.querySelector('input[name="selling_plan"]');
    if (hiddenSellingPlan && intervalSelect?.value) {
      hiddenSellingPlan.value = String(intervalSelect.value);
    }
  }, 100);
}

function updateContainerActiveState(container) {
  const optionContainers = container.querySelectorAll('.sls-option-container');
  optionContainers.forEach((optContainer) => {
    const radio = optContainer.querySelector('input[type="radio"]');
    if (radio && radio.checked) optContainer.classList.add('sls-active');
    else optContainer.classList.remove('sls-active');
  });
}

// ============================================
// MEAL SELECTION & PRICING LOGIC
// ============================================
function updateSelectedMealsPrices() {
  if (!window.currentSelectedMeals || window.currentSelectedMeals.size === 0) return;

  const productCards = document.querySelectorAll('.product-item-v7');

  productCards.forEach(card => {
    const variantId = getVariantIdFromCard(card);
    if (!variantId) return;

    syncCardCacheVariant(card);

    if (window.currentSelectedMeals.has(variantId)) {
      const newPrice = getCachedCardPrice(card);
      const mealItem = window.currentSelectedMeals.get(variantId);
      mealItem.price = newPrice;

      console.log('[MealPrice] Updated selected meal price:', {
        card: getCardDebugId(card),
        variantId,
        newPrice
      });
    }
  });
}

function calculateTotalPrice(selectedMeals) {
  if (!selectedMeals || selectedMeals.size === 0) return 0;

  let total = 0;
  selectedMeals.forEach(item => {
    total += item.price * item.quantity;
  });
  return total;
}

// NEW: calculate discounted total by applying tier % to EACH line item
function calculateTierDiscountedTotal(selectedMeals, tierPercent) {
  if (!selectedMeals || selectedMeals.size === 0) return 0;
  if (!tierPercent || tierPercent <= 0) return calculateTotalPrice(selectedMeals);

  const factor = 1 - (tierPercent / 100);

  let total = 0;
  selectedMeals.forEach(item => {
    const line = (Number(item.price) || 0) * (Number(item.quantity) || 0);
    total += line * factor;
  });

  return total;
}

function updateMealsStatus(selectedMeals) {
  const statusEl = document.querySelector('.meals-selected-status');
  const basketBtn = document.querySelector('.add-to-basket-btn');
  const priceInfoEl = document.querySelector('.price-info');

  if (!statusEl || !basketBtn) return;

  const mealCount = Array.from(selectedMeals.values()).reduce((sum, item) => sum + item.quantity, 0);
  statusEl.textContent = `${mealCount} Meals selected`;

  // Always read the sidebar discount and decide visibility (even when mealCount = 0)
  const sidebarDiscountEl = document.querySelector('.order-summary-box .discount');
  const rawDiscountText = sidebarDiscountEl ? (sidebarDiscountEl.textContent || '').trim() : '';
  const shouldShowDiscount = !isGlobalOneTime() && !!rawDiscountText;
  const discountText = shouldShowDiscount ? rawDiscountText : '';

  if (priceInfoEl) {
    const baseTotalPrice = calculateTotalPrice(selectedMeals);

    const tier = getDiscountTier(mealCount);
    const tierPercent = tier ? Number(tier.percent) : 0;

    // APPLY TO PRODUCTS (line items)
    const discountedTotalPrice = calculateTierDiscountedTotal(selectedMeals, tierPercent);
    const tierSavings = baseTotalPrice - discountedTotalPrice;

    console.log('[MealPrice] Sidebar totals:', { mealCount, baseTotalPrice, discountedTotalPrice, tierSavings, tierPercent });

    if (mealCount > 0) {
      const showTierCompare = tierPercent > 0 && baseTotalPrice > discountedTotalPrice + 0.009;

      priceInfoEl.innerHTML = `
      <p class="discount-wrap">
        <span class="discount" style="${discountText ? '' : 'display:none;'}">${discountText}</span>
        <span class="discount-two"></span>
      </p>

      <div class="main-price-wrap">
        <strong>£${discountedTotalPrice.toFixed(2)}</strong>
        ${showTierCompare ? `<div class="original-total" style="opacity:0.7;text-decoration:line-through;">£${baseTotalPrice.toFixed(2)}</div>` : ``}
      </div>

      <div class="main-per-meal-price">
        <span class="per-meal-price">${tierSavings > 0.009 ? `Save £${tierSavings.toFixed(2)}` : ``}</span>
      </div>
      `;
    } else {
      priceInfoEl.innerHTML = `
      <p class="discount-wrap">
        <span class="discount" style="${discountText ? '' : 'display:none;'}">${discountText}</span>
        <span class="discount-two"></span>
      </p>
      <div class="main-price-wrap">
        <strong>£0.00</strong>
      </div>
      <div class="main-per-meal-price">
        <span class="per-meal-price"></span>
      </div>
      `;
    }
  }

  basketBtn.disabled = mealCount === 0;
  if (mealCount > 0) {
    basketBtn.style.cursor = 'pointer';
    basketBtn.style.backgroundColor = '#B0D4A3';
    basketBtn.style.color = '#2B6316';
    basketBtn.style.borderStyle = 'solid';
  } else {
    basketBtn.style.cursor = 'not-allowed';
    basketBtn.style.backgroundColor = '#E0E0E0';
    basketBtn.style.color = '#999';
    basketBtn.style.borderStyle = 'dashed';
  }

  updateDiscountDisplay(mealCount);
}

// IMPORTANT: show discount for subscription, hide for one-time (even if 0 meals)
function updateSidebarDiscountFromCards() {
  const sidebarDiscountEl = document.querySelector('.order-summary-box .discount');
  if (!sidebarDiscountEl) return;

  // One-time => always hide
  if (isGlobalOneTime()) {
    sidebarDiscountEl.textContent = '';
    sidebarDiscountEl.style.display = 'none';
    return;
  }

  // Subscription => attempt to read Seal badge
  const firstContainer = document.querySelector('.sls-purchase-options-container');
  if (!firstContainer) {
    sidebarDiscountEl.textContent = '';
    sidebarDiscountEl.style.display = 'none';
    return;
  }

  const activeOption =
    firstContainer.querySelector('.sls-option-container.sls-active') ||
    firstContainer.querySelector('.sls-option-container');

  const badge = activeOption?.querySelector('.sls-savings-badge') || null;

  const txt = badge ? badge.textContent.trim() : '';
  sidebarDiscountEl.textContent = txt;
  sidebarDiscountEl.style.display = txt ? 'inline-block' : 'none';
}

// ============================================
// CARD SELECTION / QUANTITY ONLY (NO BUTTON)
// ============================================
function initMealSelection() {
  const productCards = document.querySelectorAll('.product-item-v7');
  if (!productCards.length) return;

  let selectedMeals = new Map();
  window.currentSelectedMeals = selectedMeals;

  productCards.forEach(card => {
    // Skip if quantity selector already exists
    if (card.querySelector('.qty-selector')) return;

    const idField = card.querySelector('select[name="id"], input[name="id"]');
    if (!idField || !idField.value) return;

    buildCardCache(card);

    // Variant listeners
    if (idField.tagName === 'SELECT') {
      idField.addEventListener('change', () => {
        console.log('[MealPrice] Variant changed:', getCardDebugId(card), idField.value);
        syncCardCacheVariant(card);
        updateSelectedMealsPrices();
        updateMealsStatus(selectedMeals);
      });
    }

    const subsSelect = card.querySelector('.sls-purchase-options-container select[name="subs_interval"]');
    if (subsSelect) {
      subsSelect.addEventListener('change', () => {
        console.log('[MealPrice] Subscription interval changed:', getCardDebugId(card), subsSelect.value);
        syncCardCacheVariant(card);
        updateSelectedMealsPrices();
        updateMealsStatus(selectedMeals);
      });
    }

    card.querySelectorAll('.sls-purchase-options-container input[type="radio"]').forEach(r => {
      r.addEventListener('change', () => {
        setTimeout(() => {
          console.log('[MealPrice] Purchase option changed:', getCardDebugId(card), getSealPurchaseType(card));
          syncCardCacheVariant(card);
          updateSelectedMealsPrices();
          updateMealsStatus(selectedMeals);
        }, 0);
      });
    });

    const priceLine = card.querySelector('.price-product');
    const container = priceLine || card;

    // QUANTITY SELECTOR - SHOWS IMMEDIATELY WITH 0
    const quantityUI = document.createElement('div');
    quantityUI.className = 'qty-selector';
    quantityUI.style.display = 'flex';
    quantityUI.style.marginTop = '8px';
    quantityUI.style.alignItems = 'center';
    quantityUI.style.justifyContent = 'center';
    quantityUI.style.gap = '4px';
    quantityUI.innerHTML = `
      <button type="button" class="qty-btn qty-minus" disabled>−</button>
      <span class="qty-display" style="min-width: 30px; text-align: center; font-weight: bold; font-size: 16px;">0</span>
      <button type="button" class="qty-btn qty-plus">+</button>
    `;

    container.appendChild(quantityUI);

    const qtyMinusBtn = quantityUI.querySelector('.qty-minus');
    const qtyPlusBtn = quantityUI.querySelector('.qty-plus');
    const qtyDisplay = quantityUI.querySelector('.qty-display');
    const variantId = String(idField.value || '');

    // PLUS BUTTON - ADD/INCREASE
    qtyPlusBtn.addEventListener('click', (e) => {
      e.preventDefault();

      if (!variantId) return;

      syncCardCacheVariant(card);
      const cardPrice = getCachedCardPrice(card);

      const isSelected = selectedMeals.has(variantId);

      if (!isSelected) {
        // First time adding
        selectedMeals.set(variantId, {
          quantity: 1,
          price: cardPrice,
          quantityUI: quantityUI,
          card: card
        });
        qtyDisplay.textContent = '1';
        updateCardMealBadge(card, 1);
      } else {
        // Increase existing
        const item = selectedMeals.get(variantId);
        item.quantity++;
        qtyDisplay.textContent = item.quantity;
        updateCardMealBadge(card, item.quantity);
      }

      // Enable minus button
      qtyMinusBtn.disabled = false;
      qtyMinusBtn.style.opacity = '1';

      updateMealsStatus(selectedMeals);
    });

    // MINUS BUTTON - DECREASE/REMOVE
    qtyMinusBtn.addEventListener('click', (e) => {
      e.preventDefault();

      if (!variantId || !selectedMeals.has(variantId)) return;

      const item = selectedMeals.get(variantId);

      if (item.quantity > 1) {
        // Decrease
        item.quantity--;
        qtyDisplay.textContent = item.quantity;
        updateCardMealBadge(card, item.quantity);
      } else {
        // Remove completely
        selectedMeals.delete(variantId);
        qtyDisplay.textContent = '0';
        updateCardMealBadge(card, 0);

        // Disable minus button when at 0
        qtyMinusBtn.disabled = true;
        qtyMinusBtn.style.opacity = '0.5';
      }

      updateMealsStatus(selectedMeals);
    });
  });

  // **FIXED**: Main basket button - NOW INCLUDES SELLING_PLAN
  const addBasketBtn = document.querySelector('.add-to-basket-btn');
  if (addBasketBtn) {
    addBasketBtn.addEventListener('click', async () => {
      if (!selectedMeals.size) return;

      // **CRITICAL FIX**: Get subscription settings from FIRST selected card
      const firstItem = Array.from(selectedMeals.values())[0];
      const firstCard = firstItem?.card;
      const purchaseType = firstCard ? getSealPurchaseType(firstCard) : 'one_time';
      const sellingPlanId = firstCard ? getSelectedSellingPlanId(firstCard) : null;

      console.log('[MealPrice] Checkout with:', { purchaseType, sellingPlanId });

      const items = Array.from(selectedMeals.entries()).map(([variantId, item]) => {
        const lineItem = {
          id: variantId,
          quantity: item.quantity
        };

        // **CRITICAL FIX**: Add selling_plan for subscriptions (Shopify requirement)
        if (purchaseType === 'subscription' && sellingPlanId) {
          lineItem.selling_plan = Number(sellingPlanId);
        }

        return lineItem;
      });

      console.log('[MealPrice] Posting to /cart/add.js items:', items);

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items })
        });

        if (response.ok) window.location.href = '/cart';
        else alert('Error adding items to cart. Please try again.');
      } catch (e) {
        console.error('Failed to add items to cart', e);
        alert('Error adding items to cart. Please try again.');
      }
    });
  }

  updateMealsStatus(selectedMeals);
}

function updateCardMealBadge(card, quantity) {
  const existingBadge = card.querySelector('.meal-count-badge');
  if (existingBadge) existingBadge.remove();

  if (quantity > 0) {
    const badge = document.createElement('div');
    badge.className = 'meal-count-badge';
    badge.textContent = `x${quantity}`;
    badge.style.position = 'absolute';
    badge.style.bottom = '0px';
    badge.style.right = '0px';
    badge.style.background = '#00000033';
    badge.style.color = '#fff';
    badge.style.padding = '6px 10px';
    badge.style.borderRadius = '4px';
    badge.style.fontSize = '90px';
    badge.style.fontWeight = 'bold';
    badge.style.zIndex = '10';
    badge.style.width = '100%';
    badge.style.height = '100%';
    badge.style.display = 'flex';
    badge.style.alignItems = 'center';
    badge.style.justifyContent = 'center';

    const imgContainer = card.querySelector('.img-product');
    if (imgContainer) {
      if (!imgContainer.style.position || imgContainer.style.position === 'static') {
        imgContainer.style.position = 'relative';
      }
      imgContainer.appendChild(badge);
    }
  }
}

// ============================================
// INITIALIZATION
// ============================================
document.addEventListener('DOMContentLoaded', function() {
  console.log('[MealPrice] init...');
  initCentralizedSubscriptionSelector();
  setTimeout(() => {
    updateSidebarDiscountFromCards();
    initMealSelection();
  }, 200);
});

const _originalApplySubscriptionToAllCards = typeof applySubscriptionToAllCards === 'function'
  ? applySubscriptionToAllCards
  : null;

if (_originalApplySubscriptionToAllCards) {
  window.applySubscriptionToAllCards = function(selectedValue) {
    _originalApplySubscriptionToAllCards(selectedValue);
    setTimeout(updateSidebarDiscountFromCards, 100);
    setTimeout(() => updateMealsStatus(window.currentSelectedMeals || new Map()), 150);
  };
}
